import Rest from '@services/Rest';

/**
 * @typedef {MessagesService}
 */
export default class MessagesService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/messages'
}
